import React from "react";
import BaseLayout from "./BaseLayout";
import { TPresentable } from "../../presenter/withStore";
import { TTranslate } from "../../service/locale/TranslationService";
import { Layout } from "antd";

const { Content } = Layout;

export interface Props {
  router: any;
  translate: TTranslate;
  children?: any;
}
export interface State extends TPresentable {}

export default class AppLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children } = this.props;

    return (
      <BaseLayout {...this.props}>
        <div className="layout">
          <Layout style={{ minHeight: "100vh" }}>
            <Content>{children}</Content>
          </Layout>
        </div>
      </BaseLayout>
    );
  }
}
